import { AfterViewChecked, AfterViewInit, Directive, Input, OnChanges, OnInit, SimpleChanges } from "@angular/core";
import { WInputBase } from "./w-input-base";
import { isBrowser } from "./w-universal";
@Directive({
    standalone: false
})
export abstract class WInputMulticolumns extends WInputBase implements OnInit, AfterViewChecked, AfterViewInit, OnChanges {

    @Input() maxColumns: number = 0; // used by multiple column layout
    @Input() minColumnWidth: number = 300; // width limit, used by multi columns
    width = 0;
    height = 0;
    cols = 1;
    columnGap = '30px';
    calculating: boolean = false;
    protected abstract get childrenCount(): number;
    protected abstract get childHeight(): number;

    get columnCount() {
        return this.maxColumns ? this.maxColumns : 1;
    }
    get mainStyleWidth() {
        return `calc(${1 / this.cols * 100} - ${this.columnGap})`;
    }
    override ngOnInit(): void {
        super.ngOnInit();
        // start with max columns and default children height
        if (this.maxColumns > 0) { 
            this.cols = this.maxColumns; 
            this.height =  Math.ceil(this.childrenCount / this.cols) * this.childHeight;
        }
        if (isBrowser) {
            this.fromEvent(window, 'resize').subscribe(() => this.updated.next());
            this.throttle(this.updated, 500).subscribe(this.calc.bind(this));
        }
    }
    ngAfterViewInit(): void {
        if (isBrowser) { this.calc(); }
    }
    ngAfterViewChecked(): void {
        // on server hangs the process
        if (isBrowser) { this.updated.next(); }
    }
    ngOnChanges(changes: SimpleChanges): void {
        if (isBrowser) { this.updated.next(); }
    }

    calc() {
        if (isBrowser) {
            const width = Math.min(document.body.clientWidth, (this._elementRef.nativeElement as HTMLElement).clientWidth);
            const minCols = Math.min(Math.floor(width / this.minColumnWidth), this.columnCount);
            const cols = Math.max(minCols, 1);
            const height = Math.ceil(this.childrenCount / cols) * this.childHeight + 2;
            if (width > 0 && (width !== this.width || cols !== this.cols || height !== this.height)) {
                // make sure we calculate after Angular cycle finished
                setTimeout(() => {
                    this.width = width;
                    this.cols = cols;
                    this.height = height;
                 });
            }
        }
    }
}